export const ROOMS_UNASSIGNED_TEXT = {
    id: 'oe.rooms.unassigned',
    defaultMessage: '{prefix}Unassigned{suffix}',
    description: 'Label text'
};

export const NO_ROOM_ASSIGNED_TEXT = {
    id: 'oe.common.noRoomAssigned',
    defaultMessage: 'No Room Assigned',
    description: 'Label text'
};
